export default __webpack_public_path__ + "static/pdf-tweet-lammas-e8347cf2ed761e7ab085f12036c47445.png";